/* Kevyt v1.4 behaviour: menu dialog + reveal. Content never depends on JS. */
(function(){
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var menu = document.getElementById('KevytMenu');
  var burger = document.getElementById('KevytBurger');
  var close = document.getElementById('KevytMenuClose');
  if (menu && burger) {
    burger.addEventListener('click', function(){ menu.showModal(); document.body.style.overflow='hidden'; });
    function shut(){ menu.close(); document.body.style.overflow=''; }
    if (close) close.addEventListener('click', shut);
    menu.addEventListener('click', function(e){ if (e.target === menu) shut(); });
    menu.addEventListener('close', function(){ document.body.style.overflow=''; });
    menu.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', shut); });
  }
  var els = document.querySelectorAll('.kv-rv');
  if (!reduce && 'IntersectionObserver' in window && els.length) {
    document.documentElement.classList.add('kvjs');
    var io = new IntersectionObserver(function(en){ en.forEach(function(e){
      if (e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
    }, {rootMargin:'0px 0px -8% 0px', threshold:.1});
    els.forEach(function(e){ io.observe(e); });
    setTimeout(function(){ els.forEach(function(e){ e.classList.add('in'); }); }, 1500);
  }
})();
